import styled from 'styled-components'

export const FilterContainer = styled.div``

export const InputWrapper = styled.div`
  input {
    width: 100%;
  }
`

export const DropDownContainer = styled.div`
  margin-top: 10px;
  overflow: auto;
  max-height: 240px;
`

export const DropDownItem = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 10px;
  border-radius: 8px;
  transition: all 0.2s cubic-bezier(0.075, 0.82, 0.165, 1);

  &:hover {
    background-color: #1C1D24;
  }

  > div {
    width: 25px;
    height: 25px;
    margin-right: 10px;
    border-radius: 50%;
    background-color: #222430;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 100%;
      height: 100%;
      border-radius: 50%;
      object-fit: cover;
    }
  }

  span {
    color: white;
  }
`
